export default __webpack_public_path__ + "static/media/datadog.f209d5bd.svg";